import JSZip from 'jszip';

const COOKIE_NAME = 'otr_catalog_likes';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

function readCookie(name) {
  if (typeof document === 'undefined') return null;
  const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name, value) {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
}

export function readLikedTrackIds() {
  try {
    const raw = readCookie(COOKIE_NAME);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id) => Number.isFinite(id) && id > 0);
  } catch {
    return [];
  }
}

export function persistLikedTrackIds(ids) {
  const unique = [...new Set(ids.filter((id) => Number.isFinite(id) && id > 0))];
  writeCookie(COOKIE_NAME, JSON.stringify(unique));
  return unique;
}

export async function downloadTracks(tracks, getTrackUrl, { onProgress } = {}) {
  const zip = new JSZip();

  for (let i = 0; i < tracks.length; i += 1) {
    const track = tracks[i];
    const url = getTrackUrl(track);
    if (!url) continue;

    onProgress?.(i + 1, tracks.length, track);

    const response = await fetch(url);
    if (!response.ok) throw new Error(`Échec du téléchargement : ${track.name}`);

    const blob = await response.blob();
    const filename = track.filename || `${track.name}.mp3`;
    zip.file(filename, blob);
  }

  const zipBlob = await zip.generateAsync({ type: 'blob' });
  const objectUrl = URL.createObjectURL(zipBlob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = 'OTR-selection.zip';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(objectUrl);
}
